export default __webpack_public_path__ + "static/media/SG15.e3970bb6.webp";